import { nanoid } from 'nanoid';
import type { STImageMarker } from '@types';
import { IMAGE_MARKER_TITLE_DEFAULT, MARKER_ICON_DEFAULT } from '../constants';
import { stEditorKrpPlayer } from '../STKrpPlayer';

function newMarkerData(): STImageMarker | undefined {
  const { atv, ath } = stEditorKrpPlayer.getCenter();
  const id = `im_${nanoid()}`;
  return {
    id,
    title: '',
    showTitle: 1,
    titleSetting: IMAGE_MARKER_TITLE_DEFAULT,
    icon: {
      type: 0,
      ath,
      atv,
      showRadar: 1,
      scaleX: 1,
      scaleY: 1,
      ...MARKER_ICON_DEFAULT,
    },
    data: { type: 0 },
  };
}

export default newMarkerData;
